import _slicedToArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useJsApiLoader } from '@react-google-maps/api';
import React, { useState } from 'react';
import memberService from '../../../../src/services/member';
import { AddressLabel } from '../../../enums/address';
import { Button, Icon } from '../../../subkit-ui';
import countries from '../../../utils/countries';
import { SelectNew } from '../../SelectNew';
import { TWInput } from '../../TWInput';
import TWServiceProfileLayout from '../../TWServiceProfileLayout/TWServiceProfileLayout.container';
import AddressConfirmModal from './AddressConfirmModal';
import { makeAddressFromGeocoderResult } from './maps';
import { OrderSummary } from './OrderSummary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var googleMapsOpts = {
  googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY,
  libraries: ['places']
};

var AddressStep = function AddressStep(_ref) {
  var _providerService$prov;

  var serviceId = _ref.serviceId,
      reload = _ref.reload,
      plan = _ref.plan,
      order = _ref.order;

  var _useState = useState({
    country: 'United States of America',
    firstName: '',
    lastName: '',
    streetAddress1: '',
    streetAddress2: '',
    city: '',
    state: '',
    zip: '',
    deliveryInstructions: ''
  }),
      userInfo = _useState[0],
      setUserInfo = _useState[1];

  var _useState2 = useState({
    firstName: false,
    lastName: false,
    streetAddress1: false,
    city: false,
    state: false,
    zip: false
  }),
      showErrorMessages = _useState2[0],
      setShowErrorMessages = _useState2[1];

  var _useState3 = useState({
    firstName: false,
    lastName: false,
    streetAddress1: false,
    city: false,
    state: false,
    zip: false
  }),
      validity = _useState3[0],
      setValidity = _useState3[1];

  var _useState4 = useState(),
      address = _useState4[0],
      setAddress = _useState4[1];

  var _useState5 = useState(false),
      showModal = _useState5[0],
      setShowModal = _useState5[1];

  var _useState6 = useState(false),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var _useJsApiLoader = useJsApiLoader(googleMapsOpts),
      googleMapsApiLoaded = _useJsApiLoader.isLoaded,
      googleMapsApiError = _useJsApiLoader.loadError;

  var handleUserInfoChange = function handleUserInfoChange(event) {
    var nextUserInfo = _objectSpread(_objectSpread({}, userInfo), {}, _defineProperty({}, event.target.name, event.target.value));

    setUserInfo(nextUserInfo);
  };

  var onSelectChange = function onSelectChange(name, value) {
    handleUserInfoChange({
      target: {
        name: name,
        value: value
      }
    });
  };

  var providerService = order.providerService; // move these out if they're still around
  // make it depend on country: UK is different than CA/US

  var makeAddressFromComponents = function makeAddressFromComponents() {
    var retval = userInfo.streetAddress1;
    if (userInfo.streetAddress2) retval = "".concat(retval, ", ").concat(userInfo.streetAddress2);
    if (userInfo.city) retval = "".concat(retval, ", ").concat(userInfo.city);
    if (userInfo.state) retval = "".concat(retval, ", ").concat(userInfo.state);
    if (userInfo.zip) retval = "".concat(retval, ", ").concat(userInfo.zip);
    retval = "".concat(retval, ", ").concat(userInfo.country);
    return retval;
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var geocoder, address, response, suggestedAddress, _response$results;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              setLoading(true);
              geocoder = new window.google.maps.Geocoder();
              address = makeAddressFromComponents();
              _context.next = 6;
              return geocoder.geocode({
                address: address
              });

            case 6:
              response = _context.sent;

              if (response !== null && response !== void 0 && response.results) {
                ;
                _response$results = _slicedToArray(response.results, 1);
                suggestedAddress = _response$results[0];
              }

              setAddress({
                userEnteredAddress: address,
                suggestedAddress: suggestedAddress
              });

              if (suggestedAddress) {
                setShowModal(true);
              } else {
                addressPicked(address);
              }

              setLoading(false);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var addressPicked = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(picked) {
      var address;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setShowModal(false);
              address = {
                label: AddressLabel.SHIPPING,
                first_name: userInfo.firstName,
                last_name: userInfo.lastName,
                formatted_address: typeof picked === 'string' ? picked : makeAddressFromGeocoderResult(picked)
              };

              if (typeof picked !== 'string') {
                address.lat = picked.geometry.location.lat();
                address.lng = picked.geometry.location.lng();
                address.place_id = picked.place_id;
              }

              if (userInfo.deliveryInstructions) address.delivery_instructions = userInfo.deliveryInstructions;
              _context2.next = 6;
              return memberService.updateAddress(serviceId, {
                addresses: [address],
                version: 1
              });

            case 6:
              reload();

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function addressPicked(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var onBlur = function onBlur(event) {
    setShowErrorMessages(_objectSpread(_objectSpread({}, showErrorMessages), {}, _defineProperty({}, event.target.name, true)));

    var newValidity = _objectSpread({}, validity);

    Object.keys(validity).forEach(function (key) {
      newValidity[key] = !!userInfo[key];
    });
    setValidity(newValidity);
  };

  var submitDisabled = !googleMapsApiLoaded || !!googleMapsApiError || !!showModal || loading || !Object.values(validity).every(function (isValid) {
    return isValid;
  });

  var streetAddressValidity = function streetAddressValidity() {
    return !new RegExp(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/).test(userInfo.streetAddress1);
  };

  return /*#__PURE__*/_jsx(TWServiceProfileLayout, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "max-w-full lg:max-w-screen-xl lg:mx-auto p-4",
      children: [/*#__PURE__*/_jsxs("a", {
        href: "/".concat(providerService === null || providerService === void 0 ? void 0 : (_providerService$prov = providerService.provider) === null || _providerService$prov === void 0 ? void 0 : _providerService$prov.slug),
        className: "flex text-gray-500 text-base font-medium no-underline mb-2",
        children: [/*#__PURE__*/_jsx(Icon, {
          name: "angle-left",
          type: "regular",
          className: "text-xl"
        }), /*#__PURE__*/_jsx("span", {
          className: "block ml-2 text-base",
          children: "Back to Profile"
        })]
      }), /*#__PURE__*/_jsx("h1", {
        className: "font-serif text-3xl m-0 ws-pre-line mt-3 capitalize",
        children: providerService === null || providerService === void 0 ? void 0 : providerService.name
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex items-center my-2 text-gray-500 text-base",
        children: [/*#__PURE__*/_jsx("span", {
          className: "block mr-2 text-gray-900",
          children: "Address & Delivery"
        }), /*#__PURE__*/_jsx(Icon, {
          name: "angle-right",
          type: "regular",
          className: "text-sm mt-1"
        }), /*#__PURE__*/_jsx("span", {
          className: "block ml-2",
          children: "Payment"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex justify-between mt-4 flex-col-reverse md:flex-row",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "w-full mt-8 md:w-1/2 md:pr-2.5 xl:pr-24 md:mt-0",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "my-5",
            children: [/*#__PURE__*/_jsx("span", {
              className: "block text-base font-medium text-gray-900",
              children: "Country"
            }), /*#__PURE__*/_jsx(SelectNew, {
              name: "country",
              options: countries.map(function (c) {
                return {
                  label: c.name,
                  value: c.name
                };
              }),
              selectedValue: userInfo.country,
              onChange: onSelectChange
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "md:flex ",
            children: [/*#__PURE__*/_jsx("div", {
              className: "my-5 md:flex-1 md:mr-3",
              children: /*#__PURE__*/_jsx(TWInput, {
                format: "rounded",
                label: "First Name",
                name: "firstName",
                value: userInfo.firstName,
                onChange: handleUserInfoChange,
                showErrorIcon: showErrorMessages.firstName && !validity.firstName,
                type: showErrorMessages.firstName && !validity.firstName ? 'error' : 'normal',
                errorText: showErrorMessages.firstName && !validity.firstName && 'First Name is required',
                onBlur: onBlur
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "my-5 md:flex-1 md:ml-3",
              children: /*#__PURE__*/_jsx(TWInput, {
                format: "rounded",
                label: "Last Name",
                name: "lastName",
                value: userInfo.lastName,
                onChange: handleUserInfoChange,
                showErrorIcon: showErrorMessages.lastName && !validity.lastName,
                type: showErrorMessages.lastName && !validity.lastName ? 'error' : 'normal',
                errorText: showErrorMessages.lastName && !validity.lastName && 'Last Name is required',
                onBlur: onBlur
              })
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "my-5",
            children: /*#__PURE__*/_jsx(TWInput, {
              format: "rounded",
              label: "Street Address",
              name: "streetAddress1",
              value: userInfo.streetAddress1,
              onChange: handleUserInfoChange,
              showErrorIcon: showErrorMessages.streetAddress1 && !validity.streetAddress1,
              type: showErrorMessages.streetAddress1 && !validity.streetAddress1 ? 'error' : 'normal',
              errorText: showErrorMessages.streetAddress1 && !validity.streetAddress1 && 'Street Address is required' || !streetAddressValidity() && 'Street Address should not be an email address',
              onBlur: onBlur
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "my-5",
            children: /*#__PURE__*/_jsx(TWInput, {
              format: "rounded",
              label: "Apt/Unit",
              name: "streetAddress2",
              value: userInfo.streetAddress2,
              onChange: handleUserInfoChange
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "my-5",
            children: /*#__PURE__*/_jsx(TWInput, {
              format: "rounded",
              label: "City",
              name: "city",
              value: userInfo.city,
              onChange: handleUserInfoChange,
              showErrorIcon: showErrorMessages.city && !validity.city,
              type: showErrorMessages.city && !validity.city ? 'error' : 'normal',
              errorText: showErrorMessages.city && !validity.city && 'City is required',
              onBlur: onBlur
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "md:flex ",
            children: [/*#__PURE__*/_jsx("div", {
              className: "my-5 md:flex-1 md:mr-3",
              children: /*#__PURE__*/_jsx(TWInput, {
                format: "rounded",
                label: "State",
                name: "state",
                value: userInfo.state,
                onChange: handleUserInfoChange,
                showErrorIcon: showErrorMessages.state && !validity.state,
                type: showErrorMessages.state && !validity.state ? 'error' : 'normal',
                errorText: showErrorMessages.state && !validity.state && 'State is required',
                onBlur: onBlur
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "my-5 md:flex-1 md:ml-3",
              children: /*#__PURE__*/_jsx(TWInput, {
                format: "rounded",
                label: "Zip Code",
                name: "zip",
                value: userInfo.zip,
                onChange: handleUserInfoChange,
                showErrorIcon: showErrorMessages.zip && !validity.zip,
                type: showErrorMessages.zip && !validity.zip ? 'error' : 'normal',
                errorText: showErrorMessages.zip && !validity.zip && 'Zip Code is required',
                onBlur: onBlur
              })
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "my-5",
            children: /*#__PURE__*/_jsx(TWInput, {
              label: "Delivery Instructions",
              multiline: true,
              maxLength: 300,
              format: "rounded",
              name: "deliveryInstructions",
              placeholder: "Tell us anything else we need to know for a seamless drop-off.",
              cornerHint: "".concat(userInfo.deliveryInstructions.length, "/300"),
              rows: 5,
              value: userInfo.deliveryInstructions,
              onChange: handleUserInfoChange,
              onBlur: onBlur
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "mt-4 md:mt-14 mb-8 md:w-3/5 lg:w-1/2",
            children: /*#__PURE__*/_jsx(Button, {
              text: 'Continue Checkout',
              "data-cy": "checkout-continue",
              size: "lg",
              icon: "check",
              iconType: "solid",
              disabled: submitDisabled,
              onClick: onSubmit
            })
          }), /*#__PURE__*/_jsx(AddressConfirmModal, {
            userEnteredAddress: address === null || address === void 0 ? void 0 : address.userEnteredAddress,
            suggestedAddress: address === null || address === void 0 ? void 0 : address.suggestedAddress,
            showModal: showModal,
            setModal: function setModal(show) {
              return setShowModal(!show);
            },
            addressPicked: addressPicked
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "w-full md:w-1/2 md:pl-2.5 xl:pl-24",
          children: /*#__PURE__*/_jsx(OrderSummary, {
            order: order,
            plan: plan
          })
        })]
      })]
    })
  });
};

export default AddressStep;